import React, { memo } from 'react';
import UseDfpSlot from './UseDfpSlot';

const Top = () => {

    UseDfpSlot({
        path: '/28253241/depor.com/web_interna_top',
        size: ['fluid', [300, 100], [1, 1], [320, 50], [320, 100]],
        id: 'gpt_top',
    });

    return (
        <div id="gpt_top"></div> 
    )
}

export default memo(Top);
